export default __webpack_public_path__ + "static/media/outline-icons.687a4990.woff2";